<script lang="ts">
	import type { PageData } from './$types';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import FiltersPanel from '$lib/components/pois/filters/FiltersPanel.svelte';
	import { ROUTE_ZOI } from '$lib/constants/route';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';

	export let data: PageData;
	$: ({ partnersLinks } = data);

	const searchParams = getSearchParamsStore();
	const {
		poiMarkerWithDetailsEnabled,
		handlePoiMarkerWithDetailsByFilterChange,
		onAccommodationSelectDates,
		onAccommodationClearDates,
		onMichelinSelectionChange,
	} = getMapLayoutContext();
</script>

<FiltersPanel
	{partnersLinks}
	withPartner={false}
	detailedView={$poiMarkerWithDetailsEnabled}
	on:goBack={() => {
		// DO NOT USE goBackWithFallback here because we want the filters to persist
		gotoWithParams(ROUTE_ZOI, $searchParams);
	}}
	on:selectDates={({ detail }) => {
		onAccommodationSelectDates(detail);
	}}
	on:clearDates={() => {
		onAccommodationClearDates();
	}}
	on:michelinSelectionChange={({ detail: isOnlyMichelin }) => {
		onMichelinSelectionChange(isOnlyMichelin);
	}}
	on:poiFilterChange={handlePoiMarkerWithDetailsByFilterChange}
/>
